<template>
  <b-modal v-model="showModal" hide-header hide-footer centered>
    <p class="font-weight-bold f-size-20 text-header">{{ title }}</p>
    <b-form>
      <InputText
        v-model="form.value"
        textFloat="Value"
        placeholder="Value"
        name="value"
        isRequired
        :isValidate="$v.form.value.$error"
        :v="$v.form.value"
        type="text"
      />
    </b-form>
    <div class="d-flex justify-content-between mt-4">
      <button
        :disabled="isLoading"
        class="cancel-button"
        @click="onCloseModal()"
      >
        Cancel
      </button>
      <button :disabled="isLoading" class="save-button" @click="onSubmit()">
        Save
      </button>
    </div>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalForm",
  components: {
    InputText
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        value: { required }
      },
    };
  },
  data: function() {
    return {
      showModal: false,
      isLoading: false,
      form: {
        id: 0,
        value: "",
        name: "",
        type: "",
        userGUID: "",
        variableId: 0
      },
    };
  },
  methods: {
    onShowModal: async function(item = false) {
      this.$v.$reset();
      if (item) this.form = { ...item };
      else this.setDefaultData();

      this.showModal = true;
    },
    setDefaultData() {
      this.form = {
        id: 0,
        value: "",
        name: "",
        type: "",
        userGUID: "",
        variableId: 0
      };
    },
    onCloseModal() {
      this.showModal = false;
    },
    onSubmit: async function() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;

      await this.axios
        .post(`${this.$baseUrl}/Customer/${this.type}/save`, this.form)
        .then((data) => {
          if (data.result == 1) this.$emit("handleSuccess", data.message);
          else this.$emit("handleFail", data.message);
        })
        .catch((err) => {
          this.$emit("handleFail", err.message);
        });
      this.isLoading = false;

      this.onCloseModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-20 {
  font-size: 20px;
}

.f-size-18 {
  font-size: 18px;
}

.cancel-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #ffffff;
  color: #8f20c6 !important;
  border-radius: 4px;
  border: 1px solid #8f20c6;
  min-width: 30%;
}

.save-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #8f20c6;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
  min-width: 30%;
}

.text-header {
  color: #242424;
}

.text-title {
  color: #575757;
}

.errorClass > .dropdown-setting-date {
  border-color: red !important;
}
</style>
